// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GridSampleView_col__3KTr8 {
  background-color: #fff;
  text-align: center;
  font-size: 20px;
  padding: 10px;
  border: solid 1px #ccc;
}`, "",{"version":3,"sources":["webpack://./src/examples/views/GridSampleView/GridSampleView.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AACF","sourcesContent":[".col {\n  background-color: #fff;\n  text-align: center;\n  font-size: 20px;\n  padding: 10px;\n  border: solid 1px #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"col": `GridSampleView_col__3KTr8`
};
export default ___CSS_LOADER_EXPORT___;
